var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.records && _vm.records.total
    ? _c("div", { staticClass: "admin-pagination-record" }, [
        _c("div", { staticClass: "admin-pagination-record__summary" }, [
          _vm._v("\n        " + _vm._s(_vm.recordSummary) + "\n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-pagination-record__controls" }, [
          _c(
            "nav",
            {
              staticClass: "admin-pagination-record__pages",
              attrs: {
                "aria-label": _vm.trans("general.pagination") || "Pagination",
              },
            },
            [
              _c(
                "ul",
                { staticClass: "pagination mb-0" },
                [
                  _c(
                    "li",
                    {
                      staticClass: "page-item pagination-prev-nav",
                      class: { disabled: !_vm.hasPrev },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "page-link",
                          attrs: {
                            href: "#",
                            "aria-label":
                              _vm.trans("general.previous") || "Previous",
                            tabindex: _vm.hasPrev ? undefined : -1,
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.goTo(_vm.currentPage - 1)
                            },
                          },
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("«"),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.pageRange, function (page, key) {
                    return _c(
                      "li",
                      {
                        key: "page-" + key,
                        staticClass: "page-item pagination-page-nav",
                        class: {
                          active: page === _vm.currentPage,
                          disabled: page === "...",
                        },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "page-link",
                            attrs: {
                              href: "#",
                              "aria-current":
                                page === _vm.currentPage ? "page" : null,
                              tabindex: page === "..." ? -1 : undefined,
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.goTo(page)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(page) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "page-item pagination-next-nav",
                      class: { disabled: !_vm.hasNext },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "page-link",
                          attrs: {
                            href: "#",
                            "aria-label": _vm.trans("general.next") || "Next",
                            tabindex: _vm.hasNext ? undefined : -1,
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.goTo(_vm.currentPage + 1)
                            },
                          },
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("»"),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "admin-pagination-record__length-control" },
            [
              _c(
                "select",
                {
                  staticClass: "form-control admin-pagination-record__select",
                  attrs: {
                    name: "page_length",
                    "aria-label": _vm.trans("general.per_page"),
                  },
                  domProps: { value: _vm.pageLength },
                  on: { change: _vm.updateValue },
                },
                _vm._l(_vm.getConfig("pagination"), function (option) {
                  return _c(
                    "option",
                    { key: option, domProps: { value: option } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(option + " " + _vm.trans("general.per_page")) +
                          "\n                "
                      ),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }